"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var AnimationObject_1 = require("./AnimationObject");
var AnimationLayersArray_1 = require("./layers/AnimationLayersArray");
var FontsMap_1 = require("./fonts/FontsMap");
var AssetsMap_1 = require("./assets/AssetsMap");
var MarkerFactory_1 = require("./markers/MarkerFactory");
var Animation = (function (_super) {
    tslib_1.__extends(Animation, _super);
    function Animation(rawData) {
        var _this = _super.call(this, rawData, rawData.v) || this;
        _this.getLayers = function () {
            return _this.layersArray.getLayers();
        };
        _this.findLayersByName = function (name) {
            return _this.layersArray.findLayersByName(name);
        };
        _this.findFirstLayerByName = function (name) {
            return _this.layersArray.findFirstLayerByName(name);
        };
        _this.findLayerByIndex = function (index) {
            return _this.layersArray.findLayerByIndex(index);
        };
        _this.getAssetsMap = function () {
            return _this.assetsMap;
        };
        _this.getFontsMap = function () {
            return _this.fontsMap;
        };
        _this.getMarkers = function () {
            return _this.markers;
        };
        _this.toPlayerData = function () {
            return _this.toRawData();
        };
        _this.clone = function () {
            return new Animation(_this.toPlayerData());
        };
        if (_this._rawData.layers) {
            _this.layersArray = new AnimationLayersArray_1.AnimationLayersArray(_this._rawData.layers, _this.version);
        }
        if (_this._rawData.assets === undefined) {
            _this._rawData.assets = [];
        }
        _this.assetsMap = new AssetsMap_1.AssetsMap(_this._rawData.assets, _this.version);
        if (_this._rawData.fonts === undefined) {
            _this._rawData.fonts = {};
        }
        if (_this._rawData.fonts.list === undefined) {
            _this._rawData.fonts.list = [];
        }
        _this.fontsMap = new FontsMap_1.FontsMap(_this._rawData.fonts.list, _this.version);
        if (_this._rawData.markers === undefined) {
            _this._rawData.markers = [];
        }
        _this.markers = _this._rawData.markers.map(function (mrk) { return MarkerFactory_1.MarkerFactory.constructMarkerFromRawData(mrk, _this.version); });
        return _this;
    }
    Object.defineProperty(Animation.prototype, "version", {
        get: function () {
            return this._rawData.v;
        },
        set: function (version) {
            this._rawData.v = version;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Animation.prototype, "name", {
        get: function () {
            return this._rawData.nm;
        },
        set: function (name) {
            this._rawData.nm = name;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Animation.prototype, "frameRate", {
        get: function () {
            return this._rawData.fr;
        },
        set: function (frameRate) {
            this._rawData.fr = frameRate;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Animation.prototype, "width", {
        get: function () {
            return this._rawData.w;
        },
        set: function (width) {
            this._rawData.w = width;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Animation.prototype, "height", {
        get: function () {
            return this._rawData.h;
        },
        set: function (height) {
            this._rawData.h = height;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Animation.prototype, "inPoint", {
        get: function () {
            return this._rawData.ip;
        },
        set: function (inPoint) {
            this._rawData.ip = inPoint;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Animation.prototype, "outPoint", {
        get: function () {
            return this._rawData.op;
        },
        set: function (outPoint) {
            this._rawData.op = outPoint;
        },
        enumerable: true,
        configurable: true
    });
    Animation.prototype.toRawData = function () {
        var data = _super.prototype.toRawData.call(this);
        data.assets = this.assetsMap.toRawData();
        data.fonts.list = this.fontsMap.toRawData();
        return data;
    };
    return Animation;
}(AnimationObject_1.AnimationObject));
exports.Animation = Animation;
//# sourceMappingURL=Animation.js.map